<template>
  <div class="text-decoration-none h-100">
    <div
      class="product-card d-inline-block border-0 position-relative h-100"
      :class="{ 'has-secondary': hasSecondaryImage }"
    >
      <IconCard
        class="position-absolute mt-4 icon-card"
        :productURL="productURL"
        :didAuctionEnd="didAuctionEnd"
        :vId="_id"
        :pId="_prodotto[0]?._id"
        :type="type"
        :class="{ 'd-flex flex-column': verticalIcons }"
      />
      <link-wrapper class="text-decoration-none bb" :location="productURL">
        <div class="card position-relative border-0">
          <img
            v-if="primaryImage"
            class="product-image primary-image"
            :src="primaryImage"
            :alt="_prodotto[0].nome"
          />
          <img
            v-if="secondaryImage"
            class="product-image secondary-image"
            :src="secondaryImage"
            :alt="_prodotto[0].nome"
          />
        </div>
      </link-wrapper>
      <!-- Contenitore Informazioni Prodotto -->
      <div class="product-card-info pt-3 pb-3 px-3 d-flex flex-column">
        <!-- Counter (se presente) -->
        <Counter
          :endDate="new Date(bidDetail.dataFine)"
          class="prod-card-counter"
          counterInnerClass=" mx-auto"
          v-if="didAuctionEnd && type ==='auction'"
        />

        <!-- Nome Prodotto e Prezzo sulla stessa riga -->
        <div class="d-flex justify-content-between align-items-start mb-2">
          <h3 class="fw-bold product-title m-0 text-start flex-grow-1">
            <link-wrapper class="text-decoration-none text-dark" :location="productURL">
              {{ _prodotto[0]?.nome }}
            </link-wrapper>
          </h3>
          <div class="price-tag text-end ms-2">
            <span class="fw-bold fs-5">{{ formatPrice }}</span>
          </div>
        </div>

        <!-- Descrizione -->
        <p v-if="descrizione" class="description text-secondary mb-3 text-start flex-grow-1">
          {{ truncateText(descrizione, 120) }}
        </p>

        <!-- Link "View the work >>" (Basso Destra) -->
        <div class="mt-auto text-end">
          <router-link :to="productURL" class="view-work-link fw-bold text-dark text-decoration-none">
            View the work >>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Rimuovi l'import inutilizzato di 'boolean' da yup
// import { boolean } from "yup";
import { singleProductMixin } from "../../../composables/singleProductMixin";
import IconCard from "../../atoms/Button/ButtonQuickActionsPack.vue";
import Counter from "../../atoms/Counter/Counter.vue";
import LinkWrapper from "../../atoms/LinkWrapper/LinkWrapper.vue";

export default {
  components: { IconCard, Counter, LinkWrapper },
  mixins: [singleProductMixin],
  props: {
    // props from mixin
    // Correggi il tipo da 'boolean' a 'Boolean'
    verticalIcons: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    productURL() {
      return this.$buildProductURL(this._prodotto[0]?._id, this._id);
    },
    primaryImage() {
      return this.immagine?.[0]?.path || null;
    },
    secondaryImage() {
      return this.immagine?.[1]?.path || null;
    },
    hasSecondaryImage() {
      return Boolean(this.secondaryImage);
    },
    // Calcola il prezzo da mostrare
    formatPrice() {
      if (this.type === 'single') {
        return this.$convertCurrency(this.prezzo);
      } else if (this.didAuctionEnd) {
        return this.$convertCurrency(this.latestAuctionOffers?.[0]?.prezzo ?? 0);
      }
      return this.$t('auctionStatus.endedAuction');
    }
  },
  methods: {
    // Metodo per troncare il testo della descrizione
    truncateText(text, limit) {
      if (!text || text.length <= limit) return text;
      return text.substring(0, limit) + '...';
    }
  }
  // ... (altro codice del componente, come metodi o lifecycle hooks, rimane invariato)
};
</script>

<style scoped>
.product-card {
  background: white;
  width: 100%;
  display: flex; /* Per permettere a .product-card-info di occupare l'altezza rimanente */
  flex-direction: column;
  height: 360px !important; /* Aumentato per contenere meglio il testo aggiuntivo */
  border-radius: 8px; /* Arrotondato */
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1); /* Ombra */
  overflow: hidden; /* Per assicurare che l'overflow venga gestito correttamente */
  transition: box-shadow 0.3s ease; /* Transizione per l'ombra al hover */
}

.product-card:hover {
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15); /* Ombra aumentata al hover */
}

.bb {
  border-bottom: 1px solid #dfe5e9 !important;
}

.card {
  width: 100%;
  overflow: hidden;
  margin: auto;
  display: flex;
  height: 200px !important; /* Altezza fissa per l'immagine */
  justify-content: center;
  align-items: center;
  border-radius: 0 !important; /* Manteniamo bordo arrotondato solo al contenitore principale */
}

.product-card-info {
  flex: 1; /* Occupa lo spazio rimanente dopo l'immagine */
  display: flex;
  flex-direction: column;
  background: #fff; /* Sfondo bianco per la parte informazioni */
  border-radius: 0 0 8px 8px; /* Arrotonda solo i bordi inferiori */
  padding-top: 12px; /* Aumentato leggermente il padding superiore */
}

.product-title {
  font-size: 1.1rem; /* Dimensione testo nome prodotto */
  line-height: 1.4;
  color: #242424;
  padding: 0; /* Rimuovi padding precedente */
}

.product-title a:hover {
  color: var(--primary-color);
  transition: all 0.3s ease-out;
}

.product-title a {
  transition: all 250ms ease;
  -webkit-transition: all 250ms ease;
}

.product-card img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.product-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.25s ease-in-out, opacity 0.25s ease-in-out,
    visibility 0.25s ease-in-out;
}

.secondary-image {
  position: absolute;
  inset: 0;
  opacity: 0;
  visibility: hidden;
  transform: scale(1);
}

.product-card.has-secondary .primary-image {
  transition: opacity 0.25s ease-in-out, visibility 0.25s ease-in-out;
}

.product-card.has-secondary:hover .secondary-image {
  visibility: visible;
  opacity: 1;
  transform: scale(1.1);
}

.product-card.has-secondary:hover .primary-image {
  visibility: hidden;
  opacity: 0;
}

.product-card a {
  align-self: center;
  color: #484848;
  display: block;
  font-size: 18px;
  line-height: 22px;
  font-weight: bold;
  transition: color 0.25s ease-in-out;
}

.product-card a:hover {
  color: var(--primary-color);
}

.icon-card {
  left: 20px;
  z-index: 1;
}

.details {
  overflow: hidden;
  padding: 0; /* Rimuovi padding precedente */
  background: #fff;
  text-align: left; /* Allineamento testo a sinistra */
  color: #606060;
  font-size: 0.9rem; /* Dimensione testo dettagli */
}

.description {
  font-size: 0.85rem; /* Dimensione testo descrizione */
  line-height: 1.3;
  margin-bottom: 0.25rem; /* Margine sotto la descrizione */
}

.vendor {
  font-size: 0.8rem; /* Dimensione testo venditore */
  margin-bottom: 0.5rem; /* Margine sotto il venditore */
}

.vendor-link {
  font-weight: normal; /* Peso normale per il link del venditore */
  transition: color 0.2s ease; /* Transizione per il link del venditore */
}

.vendor-link:hover {
  color: var(--primary-color); /* Colore al hover per il link del venditore */
}

.view-work-link {
  font-size: 0.9rem; /* Dimensione testo link */
  transition: color 0.2s ease, text-decoration 0.2s ease; /* Aggiungi transizione per la sottolineatura */
}

.view-work-link:hover {
  color: var(--primary-color);
  text-decoration: underline !important; /* Sottolineatura al hover */
}

.prod-card-counter {
  transition: opacity 0.25s ease-in-out;
  top: -50px; /* Adegua la posizione del counter */
  left: auto; /* Adegua la posizione del counter */
  right: 10px; /* Adegua la posizione del counter */
}

.product-card:hover .prod-card-counter {
  opacity: 0;
}

.product-card {
  overflow: hidden;
  /* box-shadow: 0 0 25px rgb(0 0 0 / 10%); /!* Rimossa, ora gestita dagli stili principali *!/ */
}

@media (max-width: 767.98px) {
  .prod-card-counter {
    top: -45px; /* Adegua la posizione del counter su mobile */
  }

  .product-title a {
    font-size: 0.95rem !important; /* Dimensione testo nome prodotto su mobile */
  }

  .product-title {
    padding: 0 !important; /* Rimuovi padding precedente su mobile */
  }

  .details {
    font-size: 0.8rem !important; /* Dimensione testo dettagli su mobile */
  }

  .description {
    font-size: 0.8rem; /* Dimensione testo descrizione su mobile */
  }

  .vendor {
    font-size: 0.75rem; /* Dimensione testo venditore su mobile */
  }

  .view-work-link {
    font-size: 0.85rem; /* Dimensione testo link su mobile */
  }

  .card {
    height: 180px !important; /* Altezza immagine su mobile */
  }

  .product-card {
    height: 340px !important; /* Altezza card su mobile */
  }
}
</style>
